import React, { useEffect, useRef, useState } from 'react';
import { CheckIcon } from '@heroicons/react/20/solid';

interface FloatingHintProps {
  anchorRect: DOMRect;
  value: string;
  categories: string[];
  onSelect: (val: string) => void;
  onClose: () => void;
}

const FloatingHint: React.FC<FloatingHintProps> = ({
  anchorRect,
  value,
  categories,
  onSelect,
  onClose,
}) => {
  const [query, setQuery] = useState(value);
  const panelRef = useRef<HTMLDivElement>(null);

  const filtered = query.trim() === ''
    ? categories.slice(0, 20)
    : categories
        .filter((c) =>
          c.toLowerCase().replace(/\s+/g, '').includes(query.toLowerCase().replace(/\s+/g, '')),
        )
        .slice(0, 20);

  // Close on click outside
  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (panelRef.current && !panelRef.current.contains(e.target as Node)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [onClose]);

  // Close on Esc
  useEffect(() => {
    const keyHandler = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', keyHandler);
    return () => document.removeEventListener('keydown', keyHandler);
  }, [onClose]);

  return (
    <div
      ref={panelRef}
      style={{
        position: 'fixed',
        top: anchorRect.bottom + 4,
        left: anchorRect.left,
        zIndex: 1000,
        width: 350,
      }}
      className="rounded-md shadow-lg bg-white border border-gray-200 p-2"
    >
      <input
        autoFocus
        className="w-full border px-2 py-1 mb-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
        placeholder="Начните вводить..."
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div className="max-h-60 overflow-auto text-sm">
        {filtered.length === 0 && (
          <div className="px-2 py-1 text-gray-400">Нет совпадений</div>
        )}
        {filtered.map((cat) => (
          <div
            key={cat}
            onMouseDown={() => onSelect(cat)}
            className="px-2 py-1 cursor-pointer hover:bg-blue-50 flex items-center"
          >
            {cat}
            {cat === selectedIndicator(query, cat) && (
              <CheckIcon className="h-4 w-4 text-teal-600 ml-auto" />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

function selectedIndicator(query: string, cat: string) {
  return query === cat ? cat : undefined;
}

export default FloatingHint; 